import { render, staticRenderFns } from "./videoRecorder.vue?vue&type=template&id=2b396d2f&scoped=true"
import script from "./videoRecorder.vue?vue&type=script&lang=js"
export * from "./videoRecorder.vue?vue&type=script&lang=js"
import style0 from "./videoRecorder.vue?vue&type=style&index=0&id=2b396d2f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b396d2f",
  null
  
)

export default component.exports